<template>
    <div id="partitions">
        <transition name="slide-fade" mode="out-in" appear>
            <router-view>
            </router-view>
        </transition>
    </div>
</template>

<script>
export default {
    props: {
    },
    data() {
        return {
        }
    },
    created() {
        
        this.set_breadcrumbs();
    },
    mounted: function() {
        
    },
    watch: {
    },
    methods: {
        set_breadcrumbs() {
            var that = this;
            var partitions = {
                route_name: "customer_partitions",
                name: "號碼區間"
            }
            that.$store.state.breadcrumbs = [partitions]
        },
    },
    components: {
    },
    computed: {
    }
}
</script>

<style scoped>

</style>
